// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"0d2924fb","703":"d77e0c08","787":"aadca95f"}[chunkId] + ".chunk.js";
};